import { Card, Col, Row, Radio, Button } from 'antd'
import moment from 'moment'
import React from 'react'
import { FaInfoCircle, FaPlane } from 'react-icons/fa'
import { useSelector } from 'react-redux'

const RoundTripDomasticCard = ({
    item,
    i,
    selectedValue,
    onChange,
    flightInformation = { flightInformation }
}) => {
    const roundCityLoading = useSelector((state) => state.flightRoundCity.filterLoading);
    const flightOneWayloading = useSelector((state) => state.flightOneWay.loading);
    const filterLoading = useSelector((state) => state.flightOneWay.filterLoading);
    const borderColor = item?.colorCode;

    const roundCityFlightFilterData = useSelector((state) => state.flightRoundCity.roundCityFlightFilterData);
    const lowestPrice = Math.min(...roundCityFlightFilterData.results?.flights?.map(item => item?.priceOptions?.[0]?.totalFare)?.filter(price => price !== undefined));
    return (
        <>
            <Card
                style={{ border: `1px solid ${borderColor}` }}
                className={`flights-list-item bg-white rounded-3 mb-2 ${item?.priceOptions?.[0]?.totalFare === lowestPrice ? 'single-minus' : ''} ${selectedValue === i ? 'active' : ''}`}
                loading={roundCityLoading || flightOneWayloading || filterLoading}
            >
                <Row gutter={20} key={i} onClick={() => onChange(item, i)}>
                    <Col xl={24} md={24} className='d-none d-md-block'>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <div>
                                <span className="label bg-light-danger text-danger  me-2">Departure </span>
                                <span className="text-muted text-sm">{moment(item?.departureTime).format('DD MMM YYYY')}</span>
                            </div>
                            <Radio
                                className='d-none'
                                checked={selectedValue === i}
                                onChange={() => onChange(item, i)}
                                value={i}
                            />
                            <Button type="primary" onClick={() => flightInformation(item)} className='float-end d-none d-md-flex align-items-center height-26' aria-label="Flight Details">
                                <FaInfoCircle className='me-1' /> Flight Details
                            </Button>
                        </div>
                    </Col>

                    <Col xl={24} md={24}>
                        <Row gutter={20} className="align-items-center flight-details-cntr">
                            <Col md={5} xs={13} className='pe-0' style={{ order: '-1' }}>
                                <div className="d-flex d-md-block gap-1 align-items-center justify-content-start">
                                    <div className="d-start fl-pic">
                                        <img
                                            className='img-collection result-flight'
                                            src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${item?.flightCode}.gif`}
                                            alt="logo"
                                        />
                                    </div>
                                    <div className="d-end fl-title lh-sm">
                                        <small className="text-dark fw-medium mt-1 d-none d-md-block">{item?.airline}</small>
                                        <small className="text-sm text-muted">{item?.onwardFlight?.map((subItem) => `${subItem.flightNumber}`).join(' | ')}</small>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={11} className=' d-md-none ps-0'>
                                <div className="text-dark fw-bold text-end">
                                    <p>₹{item?.priceOptions?.[0]?.totalFare.toLocaleString()}</p>
                                </div>
                            </Col>
                            <Radio
                                className='d-none'
                                checked={selectedValue === i}
                                onChange={() => onChange(item, i)}
                                value={i}
                            />

                            <Col xs={24} md={13} className='mt-1 mt-md-0 pe-md-0'>
                                <Row gutter={16} className="row gx-3 align-items-center">
                                    <Col>
                                        <div className="text-dark fw-bold">{moment(item?.departureTime).format('HH:mm')}</div>
                                        <div className="text-muted text-sm fw-medium">{item?.origin}</div>
                                    </Col>

                                    <Col flex="auto" className="text-center px-0 px-md-2">
                                        <small className="text-muted d-block lh-sm fw-medium mb-0">
                                            {(() => {
                                                if (!item?.duration) return "0H 0M";
                                                const duration = moment.duration(item.duration, 'minutes');
                                                const totalHours = Math.floor(duration.asMinutes() / 60);
                                                return `${totalHours}H ${duration.minutes()}M`;
                                            })()}
                                        </small>
                                        <div className="flightLine departure">
                                            <FaPlane className='flight-takeoff' />
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <small className="text-muted d-block lh-sm fw-medium mt-2 mt-md-3">{item.stops === 0 ? 'Direct' : `${item.stops} stop${item.stops > 1 ? 's' : ''}`}</small>
                                    </Col>

                                    <Col>
                                        <div className="text-dark fw-bold">{moment(item?.arrivalTime).format('HH:mm')}</div>
                                        <div className="text-muted text-sm fw-medium">{item?.destination}</div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col md={6} className='d-none d-md-block'>
                                <div className="text-start text-md-end">
                                    <div className="text-dark lh-base">
                                        {/* <p className="text-decoration-line-through text-danger lh-sm">₹{item?.priceOptions?.[0]?.totalFare?.toLocaleString()} </p> */}
                                        <h3 className='fw-bold'>₹{item?.priceOptions?.[0]?.after_discount_amount.toLocaleString()}</h3>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>


                {item?.priceOptions?.[0]?.totalFare === lowestPrice && (
                    <p className='cheapest_price'>Lowest Price</p>
                )}

            </Card >
        </>
    )
}

export default RoundTripDomasticCard